var React = require('react');

function Heart (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.94 3.25C10.75 1.34 12.59 0 14.74 0 17.63 0 19.71 2.47 19.97 5.42 19.97 5.42 20.11 6.15 19.8 7.47 19.38 9.26 18.38 10.85 17.04 12.07L9.94 18.4 2.96 12.07C1.62 10.85 0.62 9.26 0.2 7.47 -0.11 6.15 0.03 5.42 0.03 5.42 0.29 2.47 2.37 0 5.26 0 7.41 0 9.13 1.34 9.94 3.25L9.94 3.25Z"}));
}

Heart.defaultProps = {"viewBox":"0 0 20 19"};

module.exports = Heart;

Heart.default = Heart;
